<template>
  <b-row>
    <b-col cols="12" md="12" xl="12" lg="12">
      <b-img
        v-if="isSaldobrasata == true"
        :style="'cursor: pointer'"
        rounded="circle"
        :src="ispezionabiliImg"
        width="100"
        height="100"
        @click="loadPlatePrices(false)"
      />
      <b-img
        v-if="isSaldobrasata == false"
        :style="'border: solid black 1px;cursor: pointer;'"
        width="100"
        height="100"
        rounded="circle"
        :src="ispezionabiliImg"
        @click="loadPlatePrices(false)"
      />
      <b-img
        v-if="isSaldobrasata == true"
        :style="'border: solid black 1px; cursor: pointer'"
        rounded="circle"
        :src="saldobrasateImg"
        width="100"
        height="100"
        @click="loadPlatePrices(true)"
      />
      <b-img
        v-if="isSaldobrasata == false"
        :style="'cursor: pointer'"
        rounded="circle"
        :src="saldobrasateImg"
        width="100"
        height="100"
        @click="loadPlatePrices(true)"
      />
      <b-row style="margin-top: 10px">
        <b-col cols="12" md="6" lg="3" xl="3">
          <b-button block variant="success" @click="callExport"
            ><i :class="'fa-solid fa-file-arrow-down fa-2x'"></i
          ></b-button>
        </b-col>
        <b-col cols="12" md="6" lg="3" xl="3">
          <b-button block variant="success" @click="setFile"
            ><i :class="'fa-solid fa-file-arrow-up fa-2x'"></i
          ></b-button>

          <b-form-file
            id="inputPlatePricesExcel"
            v-model="file"
            style="visibility: hidden"
            :state="Boolean(file)"
            placeholder="###Choose a file or drop it here..."
            drop-placeholder="###Drop file here..."
          ></b-form-file>
        </b-col>
      </b-row>
    </b-col>
    <b-col cols="12" md="12" xl="12" lg="12">
      <b-table
        sticky-header="72vh"
        style="height: 493px;margin-top: 10px"
        hover
        fixed
        :items="items"
        :fields="visibleFields"
      >
        <template #cell(actions)="row">
          <!--
          <b-button size="xl" variant="danger" @click="deleteMaterial(row.item)">
            <i class="fa-regular fa-trash-can"></i>
          </b-button>
          -->
        </template>
        <template #cell(prezzo)="data">
          {{ data.value.toFixed(2) }}
        </template>
      </b-table>
    </b-col>

    <!-- -->
    <b-modal v-model="showExcelExport" no-close-on-backdrop hide-footer hide-header>
      <b-card
        :style="{
          backgroundColor: coloreSfondo,
          color: coloreTesto,
          borderColor: coloreBordo
        }"
        class="card-panel"
        style="margin-bottom:0px;"
      >
        <div slot="header" :style="{ color: coloreTitolo, backgroundColor: coloreBarraTitolo }">
          <!-- Secondary Side --><b>{{ uniTranslation("TRNSL151") }} </b>
        </div>
        <b-row style="margin-bottom: 10px;">
          <b-col>
            {{ uniTranslation("TRNSL32") }}
          </b-col>
        </b-row>
        <b-form-input v-model="fileName" type="text" :state="nameState"></b-form-input>
        <b-form-invalid-feedback id="input-live-feedback">
          {{ uniTranslation("TRNSL33") }}
        </b-form-invalid-feedback>

        <b-row style="padding-top: 10px">
          <b-col></b-col>
          <b-col cols="2" md="2" lg="2" xl="2">
            <b-button block variant="danger" @click="setExportModal(false)"
              ><i class="fa-regular fa-circle-xmark"></i></b-button
          ></b-col>
          <b-col cols="2" md="2" lg="2" xl="2">
            <b-button block variant="success" @click="exportExcel"
              ><i class="fa-regular fa-circle-check"></i
            ></b-button>
          </b-col>
        </b-row>
      </b-card>
    </b-modal>
    <!-- -->
    <!-- MODALE DEGLI ERRORI PRESENTI IN EXCEL -->
    <b-modal v-model="showExcelErrors" size="xl" no-close-on-backdrop hide-footer hide-header>
      <b-row>
        <b-col>
          <label>
            <b>
              <h3 style="text-transform: uppercase">
                <i style="color: red" class="fa-solid fa-triangle-exclamation"></i>
                {{ uniTranslation("TRNSL68") }}
                <i style="color: red" class="fa-solid fa-triangle-exclamation"></i>
              </h3>
            </b>
          </label>
        </b-col>
      </b-row>
      <b-table
        sticky-header="60vh"
        style="height: 80vh;margin-top: 10px"
        hover
        fixed
        :items="itemsExcelErrors"
        :fields="visibleErrorsFields"
      >
      </b-table>
      <b-row style="padding-top: 10px">
        <b-col></b-col>
        <b-col cols="2" md="2" lg="2" xl="2">
          <b-button block variant="danger" @click="setErrorExcelModal(false)"
            ><i class="fa-regular fa-circle-xmark"></i></b-button
        ></b-col>
      </b-row>
    </b-modal>
    <!-- -->
  </b-row>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { Notification } from "element-ui";

export default {
  components: {},
  props: {},
  data() {
    return {
      file: null,
      items: [],
      showExcelExport: false,
      itemsToExport: [],
      fileName: "",
      coloreSfondo: "",
      coloreTesto: "",
      coloreBordo: "",
      coloreTitolo: "",
      coloreBarraTitolo: "",
      itemsExcelErrors: [],
      showExcelErrors: false,
      ispezionabiliImg: "",
      saldobrasateImg: "",
      isSaldobrasata: false,
      uploadModel: {}
    };
  },
  computed: {
    ...mapGetters("_prjModule", ["projects"]),
    ...mapGetters("_colorsModule", ["cardColors"]),
    nameState() {
      var that = this;
      return that.fileName.length > 0 ? true : false;
    },
    visibleFields() {
      return this.fields.filter(field => field.visible);
    },
    visibleErrorsFields() {
      return this.errorsFields.filter(field => field.visible);
    },
    fields() {
      return [
        {
          key: "guiD_PlateGeometry",
          label: this.uniTranslation("TRNSL225"),
          sortable: true,
          visible: true
        },
        {
          key: "guiD_Material",
          label: this.uniTranslation("TRNSL226"),
          sortable: true,
          visible: true
        },
        {
          key: "guiD_Pressione",
          label: this.uniTranslation("TRNSL217"),
          sortable: true,
          visible: this.isSaldobrasata
        },
        {
          key: "minPiaste",
          label: this.uniTranslation("TRNSL227"),
          sortable: true,
          visible: this.isSaldobrasata
        },
        {
          key: "prezzo",
          label: this.uniTranslation("TRNSL224"),
          sortable: true,
          visible: true
        }
      ];
    },
    errorsFields: function() {
      return [
        {
          key: "action",
          label: this.uniTranslation("TRNSL07"),
          sortable: true,
          visible: true
        },
        {
          key: "exchangerCode",
          label: this.uniTranslation("TRNSL251"),
          sortable: true,
          visible: true
        },
        {
          key: "geometryDescription",
          label: this.uniTranslation("TRNSL225"),
          sortable: true,
          visible: true
        },
        {
          key: "materialCode",
          label: this.uniTranslation("TRNSL226"),
          sortable: true,
          visible: true
        }
      ];
    }
  },
  watch: {
    file: function() {
      if (this.file != null) {
        this.upload();
      }
    },
    cardColors() {
      this.setColors();
    }
  },
  mounted: function() {
    var that = this;
    that.setColors();

    that.getImageModAction("PIASTRE_ISPEZIONABILI.jpg").then(data => {
      that.ispezionabiliImg = data;
    });
    that.getImageModAction("PIASTRE_SALDOBRASATE.jpg").then(data => {
      that.saldobrasateImg = data;
    });

    that.getExportModelPlatesAction().then(data => {
      that.uploadModel = data;
    });
    that.loadPlatePrices(that.isSaldobrasata);
  },
  methods: {
    ...mapActions("_pricesModule", [
      "getPlatePricesWeightListAction",
      "getBrazedPricesWeightListAction",
      "getPlatePricesWeightExportListAction",
      "getBrazedPricesWeightExportListAction",
      "postUpdateAddAllExport_PlateAction",
      "postUpdateAddAllExport_BrazedAction",
      "getExportModelPlatesAction"
    ]),
    ...mapActions("_commonModule", ["setLoading"]),
    ...mapActions("_dashboardModule", ["getImageModAction"]),

    setColors() {
      var that = this;
      that.coloreSfondo = that.cardColors[0] + " !important"; // 7 elementi. 0=sfondo 1=barra titolo 2=testo 3=colore titolo 4= sfondo tab 5=testo tab 6=testo titolo tab quando selezionata
      that.coloreBarraTitolo = that.cardColors[1];
      that.coloreTesto = that.cardColors[2];
      that.coloreTitolo = that.cardColors[3];
      that.coloreSfondoTab = that.cardColors[4];
      that.coloreTestoTab = that.cardColors[5];
      that.coloreBordo = that.cardColors[6];
    },
    exportExcel() {
      var that = this;
      var ws = XLSX.utils.json_to_sheet(that.itemsToExport);
      var wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "PlatePrices");
      XLSX.writeFile(wb, that.fileName + ".xls");
      that.setExportModal(false);
    },

    loadPlatePrices(bool) {
      var that = this;
      that.isSaldobrasata = bool;
      that.setLoading({ bool: true, icon: "fa-solid fa-clock fa-5x" });
      if (that.isSaldobrasata) {
        that.getBrazedPricesWeightListAction().then(data => {
          that.items = data;
          that.setLoading({ bool: false, icon: "fa-solid fa-clock fa-5x" });
        });
      } else {
        that.getPlatePricesWeightListAction().then(data => {
          that.items = data;
          that.setLoading({ bool: false, icon: "fa-solid fa-clock fa-5x" });
        });
      }
    },
    callExport() {
      var that = this;
      if (that.isSaldobrasata) {
        that.getBrazedPricesWeightExportListAction().then(data => {
          that.itemsToExport = data;
          that.fileName = that.getDefaultFileName();
          that.setExportModal(true);
        });
      } else {
        that.getPlatePricesWeightExportListAction().then(data => {
          that.itemsToExport = data;
          that.fileName = that.getDefaultFileName();
          that.setExportModal(true);
        });
      }
    },
    setExportModal(bool) {
      this.showExcelExport = bool;
    },
    getDefaultFileName() {
      var today = new Date();
      var dd = String(today.getDate()).padStart(2, "0");
      var mm = String(today.getMonth() + 1).padStart(2, "0");
      var yyyy = today.getFullYear();
      today = yyyy + "_" + mm + "_" + dd;

      var name = "PricesWeightExport_";
      if (this.isSaldobrasata) {
        name = "BrazedPricesWeightExport_";
      } else {
        name = "PlatePricesWeightExport_";
      }

      return name + today;
    },
    /*
      ===============================================================================================
      MARCO DC
      Per importare file excel ho trovato questa estenzione
      https://stackoverflow.com/questions/57672887/how-to-convert-all-excel-data-to-json-in-vuejs

      con licenza (Apache License, Version 2.0 licensed)
      https://opensource.stackexchange.com/questions/4713/can-i-use-a-apache-v2-licensed-driver-for-a-commercial-project-without-revealing
      => da quello che c'è scritto la possiamo usare a scopo commerciale
    */

    upload() {
      var f = this.file;
      var that = this;
      var reader = new FileReader();
      reader.onload = function(e) {
        var data = new Uint8Array(e.target.result);
        var workbook = XLSX.read(data, { type: "array" });
        let sheetName = workbook.SheetNames[0];
        /* DO SOMETHING WITH workbook HERE */
        let worksheet = workbook.Sheets[sheetName];
        var list = XLSX.utils.sheet_to_json(worksheet);
        that.file = null;

        if (that.checkObjectBeforeUpload(list) == false) {
          Notification.error({
            title: that.uniTranslation("TRNSL219"),
            duration: 1500,
            offset: 36
          });
          return;
        }

        if (that.isSaldobrasata) {
          that.setLoading({ bool: true, icon: "fa-solid fa-clock fa-5x" });
          that.postUpdateAddAllExport_BrazedAction(list).then(data => {
            that.setLoading({ bool: false, icon: "fa-solid fa-clock fa-5x" });
            that.loadPlatePrices(that.isSaldobrasata);

            Notification.success({
              title: that.uniTranslation("TRNSL34"),
              message: that.uniTranslation("TRNSL35"),
              duration: 2800,
              offset: 36
            });
            if (data.length > 0) {
              that.itemsExcelErrors = data;
              that.setErrorExcelModal(true);
            }
          });
        } else {
          that.setLoading({ bool: true, icon: "fa-solid fa-clock fa-5x" });
          that.postUpdateAddAllExport_PlateAction(list).then(data => {
            that.setLoading({ bool: false, icon: "fa-solid fa-clock fa-5x" });
            that.loadPlatePrices(that.isSaldobrasata);
            if (data.length > 0) {
              that.itemsExcelErrors = data;
              that.setErrorExcelModal(true);
            }
          });
        }
      };
      reader.readAsArrayBuffer(f);
    },
    setFile() {
      document.getElementById("inputPlatePricesExcel").click();
    },
    setErrorExcelModal(bool) {
      this.showExcelErrors = bool;
    },
    checkObjectBeforeUpload(data) {
      var that = this;
      var mustHaveKeys = Object.keys(that.uploadModel);
      var toUploadKeys = Object.keys(data[0]);

      var res = true;

      mustHaveKeys.forEach(key => {
        var index = toUploadKeys.indexOf(key);
        if (index == -1) {
          res = false;
        }
      });

      return res;
    }
  }
};
</script>

<style lang="scss">
.card .card-header {
  color: transparent;
  background-color: transparent;
  padding: 0px;
}
</style>
